import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import "./styles/Home.css"
import "./styles/estandar/ButtonStyles.css"
import MenuBar from "../components/MenuBar";
import MenuHomeBox from "../components/MenuHomeBox";
import LogHomeBox from "../components/LogHomeBox";
import { validatePropertyDeps } from "ajv/dist/vocabularies/applicator/dependencies";
import Cookies from 'js-cookie';

//RePPRA
const Home = () =>{

     const navigate = useNavigate();
    /*Funcion para validar el tipo de session*/
    const [admin, setAdmin] = useState(false);
    const validarSesion = () =>{
            if(Cookies.get("turid")){
                const turid = Cookies.get("turid");
                if(turid === "rid1"){
                    setAdmin(true);
                }else if(turid !== "rid2"){
                    navigate("/");
                    Cookies.remove("usr");
                    Cookies.remove("turid");
                }
            }else{
                navigate("/");
                Cookies.remove("usr");
            }

    }

    useEffect(() =>{
        validarSesion();
    },[])
  

    return(
        <div className="mainHomeBox">
            <MenuBar pagina="" sesion={admin}/>
            <div className="mainHomeBody">
                <div className="titleHome">
                    <h1>Menú principal</h1>    
                </div>
                <div className="contentHome">
                    <MenuHomeBox/>
                    {admin &&<LogHomeBox/> }
                </div>

            </div>
            
        </div>
    );
}

export default Home;